import React from 'react';
import styled, { css } from 'styled-components';
import type { TippyProps } from '@tippyjs/react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const StyledTippy = styled(Tippy)<{ $isBright?: boolean }>`
  font-family: var(--font-family-default);
  font-size: var(--font-size-default);
  ${({ $isBright }) => !$isBright && css`
    background-color: var(--color-primary-element-hover);
    color: var(--color-text-bright);

    .tippy-arrow {
      color: var(--color-primary-element-hover);
    }
  `}
  ${({ $isBright }) => $isBright && css`
    background-color: var(--color-background-default);
    color: var(--color-primary-element-hover);

    .tippy-arrow {
      color: var(--color-background-default);
    }
  `}
`;

// As the tooltip children can have any block content we need
// to wrap it into a inline block element.
// If we don't do this the tooltip could be badly aligned
// (see audience reach info icon on medium detail page as an example)
const ChildrenWrapper = styled.span`
  display: inline-block;
`;

type Props = {
  content?: TippyProps['content'];
  offset?: TippyProps['offset'];
  isBright?: boolean;
  placement?: TippyProps['placement'];
} & React.PropsWithChildren;
const Tooltip: React.FC<Props> = ({
  children, content, offset, isBright, placement,
}) => {
  if (!content) {
    return <>{children}</>;
  }
  return (
    <StyledTippy
      content={content}
      $isBright={isBright}
      placement={placement || 'right'}
      delay={[500, 200]}
      offset={offset}
    >
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </StyledTippy>
  );
};

export default Tooltip;
